import styled from 'styled-components';
import { EllipsisTooltip } from '@components/common';
import { Button, Layout, Menu } from 'antd';

const { Sider, Content } = Layout;

export const StyledLayout = styled(Layout)`
  height: calc(100% - 120px);
  padding-bottom: 10px;
`;

export const StyledSider = styled(Sider)`
  background-color: #fafafa;
  transition: all 0.3s ease;

  .ant-layout-sider-children {
    background: #fafafa;
    padding-top: 15px;
  }
`;

export const StyledContent = styled(Content)<{ collapsed: boolean }>`
  background-color: #fff;
  padding: 0 0 24px;
  margin-left: ${({ collapsed }) => (collapsed ? '10px' : 0)};
  min-height: 280px;
`;

export const CollapseWrapper = styled.div`
  position: absolute;
  inset: 0 100%;
  z-index: 1;
`;

export const Wrapper = styled.div`
  .ant-table-container {
    font-size: 14px;

    td {
      vertical-align: top !important;
    }
  }
`;

export const StyledMenu = styled(Menu)`
  background: #fafafa;
  max-height: 100%;
  overflow: scroll;
  scrollbar-width: thin;
  scrollbar-gutter: stable;

  .ant-menu-item-disabled.ant-menu-item-selected {
    background-color: #1890ff !important; /* Active background color */
    color: white !important; /* Text color when active */
  }

  .ant-menu-submenu .ant-menu-item-group-title {
    padding-inline-start: 16px !important;
  }
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  font-weight: 500;
  width: 90%;
  align-self: center;
`;

export const StyledChildren = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: space-between;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const StyledLabel = styled.span`
  color: #4a4a4a;
`;

export const StyledNoAlert = styled.div`
  padding: 20px 20px 20px 15px;
  text-align: center;
  max-width: inherit;
`;

export const StyledStatusText = styled.div`
  font-size: 16px;
  font-weight: 450;
`;

export const StyledSubText = styled.p`
  font-size: 14px;
  color: #333;
  font-style: italic;
`;

export const Navig = styled.div<{ collapsed?: boolean }>`
  width: ${(props) => (props.collapsed ? '16px' : '3px')};
  position: absolute;
  background: #f5f5f5;
  inset-block: 0;
  inset-inline-start: -1px;
  pointer-events: none;
`;

export const TriggerButton = styled(Button)<{ collapsed?: boolean }>`
  width: 26px;
  height: 26px;
  z-index: 1;
  padding: 0;
  position: absolute;
  background-color: #fff;
  border-radius: 50%;
  right: ${(props) => (props.collapsed ? '-26px' : '-14px')};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  top: 25px;

  /* Hover styles with higher specificity */
  &:hover,
  &:hover:not(:disabled) {
    border-color: #096dd9 !important;
    background-color: #096dd9 !important;
    color: white !important;
    box-shadow: 0 2px 8px rgb(0 0 0 / 15%) !important;
  }

  /* Focus styles */
  &:focus,
  &:focus:not(:disabled) {
    border-color: #096dd9 !important;
    background-color: #096dd9 !important;
    color: white !important;
    box-shadow: 0 2px 8px rgb(0 0 0 / 15%) !important;
  }

  span {
    position: relative;
    vertical-align: middle;
  }
`;

export const SeverityLabel = styled.span<{ color }>`
  color: ${(props) => props.color};
`;
